import { FatalError } from '@rehaje/errors'

import type { Locales } from '@rehaje/errors'

export class FatalSchemaDefinitionError extends FatalError {
  static override locales: Locales = {
    'en-US': 'SchemaDefinition name must start with Schema.',
    'zh-CN': 'SchemaDefinition 的名字必须由 Schema. 开头',
    'zh-HK': 'SchemaDefinition 的名字必須由 Schema. 開頭'
  }

  override name = 'FatalSchemaDefinitionError' as const

  constructor() {
    super()
  }
}
